import styled, { createGlobalStyle } from "styled-components/macro";
import ReactSelect from "react-select";

import {
  borderRadius,
  boxShadow,
  colors,
  fontStyle,
  fontSize,
  space,
  transition,
  zIndex,
  iconSize,
} from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";
import { motion } from "framer-motion";

export const SelectContainer = styled.div`
  display: inline-flex;
  flex-shrink: 0;
`;

export const StyledActionSelect = styled(ReactSelect)`
  // override styles
  && .action-select {
    &__control {
      cursor: pointer;

      flex-wrap: nowrap;
      min-height: fit-content;

      border: 1px solid ${colors.grey2};
      padding: calc(${space.xxs} + 1px) ${space.s} calc(${space.xxs} + 2px);
      background-color: ${colors.grey1};
      border-radius: ${borderRadius.s};

      color: ${colors.white};
      ${fontSize.xs}
      ${fontStyle.bold}

      ${hoverFocus.defaultHover(colors.grey3)};

      &--is-focused {
        ${hoverFocus.focusStyle};
      }

      &--menu-is-open {
        .action-select__indicators {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }

    &__value-container {
      svg {
        height: ${iconSize.m};
        width: ${iconSize.m};

        margin-right: ${space.xs};
      }

      input {
        height: 1px; // hidden field
      }
    }

    &__single-value {
      position: relative;
      top: auto;
      transform: none;

      color: ${colors.white};
    }

    &__indicators {
      margin-left: ${space.xs};

      svg {
        width: ${iconSize.s};
        height: ${iconSize.s};

        color: ${colors.grey4};

        transition: transform ${transition.default};
      }
    }

    &__value-container {
      padding: 0;
      flex-wrap: nowrap;
    }
  }
`;

export const StyledActionSelectPortal = createGlobalStyle`
  .action-select {
    &__menu {
      // override styles
      && {
        width: 100%;

        background-color: ${colors.grey1};
        box-shadow: ${boxShadow.l};
      }
    }

    &__option {
      // override styles
      && {
        cursor: pointer;

        min-width: 100%;
        width: max-content;
        max-width: 150px;

        text-align: left;
        ${fontSize.xs}
        ${fontStyle.bold}
            color: ${colors.white};

        &--is-focused {
          background-color: ${colors.grey2};
        }

        &--is-selected {
          background-color: ${colors.grey3};
        }
      }
    }
  }
`;

// add classes to button to override classless button styles
export const StyledOption = styled.div`
  width: 100%;
`;

export const StyledMenu = styled(motion.div)`
  position: relative;
  z-index: ${zIndex.above};
`;
